import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";

import {
  getAllAuditInfoAPI,
  getAllAuditsByCompanyAPI,
  getLoginAPI,
  getNewSessionAPI,
} from "../../config/constants";
import { fetchWithAuth } from "../../components/auth/AuthenticateUser";
 
interface headerState {
  isUserITAdmin: boolean;
  //isITAdmin: boolean;
  isCompanyChanged: boolean;
  configuration: { VersionNumber: string; HeaderDisplay: string };
  user: { WWID: string; EmailID: string; FirstName: string; LastName: string };
  companyList: any[];
  selectedCompanyId: any;
  orgCompanyId: any;
  newCompanyId: any;
  auditList: any[];
  selectedAuditId: any;
  selectedAudit: {
    AuditID: number;
    AuditCode: string;
    AuditType: string;
    AuditSite: string;
    AuditStatus: string;
    AuditStartDate: string;
    AuditEndDate: string;
    isGuest: boolean;
    isSME: boolean;
    isScribe: boolean;
    isHost: boolean;
    isSRC: boolean;
    isTeamLeader: boolean;
    isTeamMember: boolean;
    isUserAdmin: boolean;
    ServerDelta: number;
  };
  isLoading: boolean;
  isTimerUp: boolean;
  lastUpdateTime: string;
  userLoginStatus: number;
  getAuditsByCompanyStatus: number;
  sessionId: string;
  sessionCreatedOn?: string;
  invalidATMSUser: boolean;
  userAlreadyLoggedIn: boolean;
}
 
const initialState: headerState = {
  configuration: { VersionNumber: "", HeaderDisplay: "" },
  user: { WWID: "", EmailID: "", FirstName: "", LastName: "" },
  companyList: [],
  selectedCompanyId: 0,
  orgCompanyId: 0,
  newCompanyId: 0,
  auditList: [],
  selectedAuditId: 0,
  isLoading: false,
  isUserITAdmin: false,
  //isITAdmin: false,
  isCompanyChanged: false,
  selectedAudit: {
    AuditID: 0,
    AuditCode: "",
    AuditType: "",
    AuditSite: "",
    AuditStatus: "",
    AuditStartDate: "",
    AuditEndDate: "",
    isGuest: false,
    isSME: false,
    isScribe: false,
    isHost: false,
    isSRC: false,
    isTeamLeader: false,
    isTeamMember: false,
    isUserAdmin: false,
    ServerDelta: 0,
  },
  isTimerUp: false,
  lastUpdateTime: "",
  userLoginStatus: 0,
  getAuditsByCompanyStatus: 0,
  sessionId: "",
  invalidATMSUser: false,
  userAlreadyLoggedIn: false
};
 
export const getUserLogin = createAsyncThunk(
  "login/getUserLogin",
  async (payload: any) => {
    const response = await fetchWithAuth(`${getLoginAPI}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payload }),
    });
    return response.json();
  },
);
 
export const getAllAuditsByCompany = createAsyncThunk(
 
  "login/getAllAuditsByCompany",
  async (payload: any) => {
    const response = await fetchWithAuth(getAllAuditsByCompanyAPI, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
   
    return response.json();
  },
);
 
export const getAllAuditsByCompany1 = createAsyncThunk(
  "login/getAllAuditsByCompany1",
  async (CompanyID: any) => {
    const response = await fetchWithAuth(`${getAllAuditInfoAPI}/${CompanyID}`);
    return response.json();
  },
);

export const getNewSession = createAsyncThunk(
  "login/getNewSession",
  async (_, { rejectWithValue }) => {
    const response = await fetchWithAuth(getNewSessionAPI);
    const data = await response.json(); // read once
 
    if (!response.ok) {
      return rejectWithValue({
        status: response.status,
        ...data,
      });
    }
    return data;
  },
);
 
 
// export const getNewSession = createAsyncThunk(
//   "login/getNewSession",
//   async () => {
//     const response = await fetchWithAuth(getNewSessionAPI);
//     return response.json();
//   },
// );
 
export const headerSlice = createSlice({
  name: "headerData",
  initialState,
  reducers: {
    setLastUpdateTimer(state, action: PayloadAction<{ time: string }>) {
      state.lastUpdateTime = action.payload.time;
    },
    handleTimer(state, action: PayloadAction<{ isTimerUp: boolean }>) {
      state.isTimerUp = action.payload.isTimerUp;
    },
    create_update_audit(
      state,
      action: PayloadAction<{ auditList: any; selectedAudit: any }>,
    ) {
      state.auditList = action.payload.auditList;
      state.selectedAudit = action.payload.selectedAudit;
      state.selectedAuditId = action.payload.selectedAudit?.AuditID || 0;
    },
    handleSelectAuditChange(state, action: PayloadAction<{ audit: any }>) {
      state.selectedAudit = action.payload.audit;
      state.selectedAuditId = action.payload.audit?.AuditID || 0;
    },
    setCurrentSelecetedCompany(
      state,
      action: PayloadAction<{ currentSelectedCompany?: string }>,
    ) {
      state.isCompanyChanged = true;
      state.selectedCompanyId =
        action.payload.currentSelectedCompany ?? action.payload;
    },
    setUserInfo(
      state,
      action: PayloadAction<{ WWID: string; EmailID: string }>,
    ) {
      state.user.WWID = action.payload.WWID;
      state.user.EmailID = action.payload.EmailID;
    },
    setInvalidATMSUser(state, action: PayloadAction<boolean>) {
      state.invalidATMSUser = action.payload;
    },
    setUserAlreadyLoggedIn(state, action: PayloadAction<boolean>) {
      state.userAlreadyLoggedIn = action.payload;
    },
    setNewCompanyId(state, action: PayloadAction<any>) {
      state.newCompanyId = action.payload;
    },
     clearSession: (state) => {
      state.sessionId = "";
      state.sessionCreatedOn = "";
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<headerState>) => {
    builder.addCase(getUserLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserLogin.fulfilled, (state, action) => {
      const data = action.payload?.loginHeader;
      state.userLoginStatus = action.payload?.status;
      state.isLoading = false;
      state.configuration = data?.configuration?.[0] || state.configuration;
      state.user = data?.selectedCompany?.[0] || state.user;
      state.companyList = data?.selectAllCompany || [];
      state.orgCompanyId = data?.selectedCompany?.[0]?.CompanyID || 0;
      state.selectedCompanyId = data?.selectedCompany?.[0]?.CompanyID || 0;
      state.auditList = data?.defaultcompanyAudit || [];
      state.selectedAuditId = data?.selectedCompany?.[0]?.AuditID || 0;
      state.isUserITAdmin = !!data?.isAdmincount?.length;
      


      state.selectedAudit =
        data?.defaultcompanyAudit?.[0] || state.selectedAudit;
      state.sessionId = data?.userSessionDetails?.SessionID || "";
      state.sessionCreatedOn = new Date().toISOString();
    });
    builder.addCase(getUserLogin.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getAllAuditsByCompany.fulfilled, (state, action) => {
      state.getAuditsByCompanyStatus = action.payload?.status;
      state.auditList =
        action.payload?.updatedUserSession?.data?.defaultcompanyAudit || [];
      state.selectedAudit = state.auditList[0] || state.selectedAudit;
      state.isLoading = false;
    });
    builder.addCase(getAllAuditsByCompany1.fulfilled, (state, action) => {
      state.auditList = action.payload?.data || [];
      state.selectedAudit = state.auditList[0] || state.selectedAudit;
      state.isLoading = false;
    });
    builder.addCase(getNewSession.fulfilled, (state, action) => {
      state.sessionId = action.payload?.sessionId || state.sessionId;
      state.sessionCreatedOn = new Date().toISOString();
    });
  },
});
 
export const {
  handleSelectAuditChange,
  setCurrentSelecetedCompany,
  handleTimer,
  setLastUpdateTimer,
  create_update_audit,
  setUserInfo,
  setInvalidATMSUser,
  setNewCompanyId,
  setUserAlreadyLoggedIn,
  clearSession
} = headerSlice.actions;
 
export default headerSlice.reducer;
 
 